export const MENU = [
  {
    id: "fried",
    label: "Famous Fried Artichokes",
    short: "Fried Artichokes",
    time: "Served hot all day",
    items: [
      {
        title: "Fried Artichokes — 10 pc",
        price: "$9.75",
        desc: "Golden, crispy artichoke hearts served hot with house dipping sauce",
      },
      {
        title: "Fried Artichokes — 20 pc",
        price: "$14.50",
        desc: "The shareable middle ground. Extra napkins included",
      },
      {
        title: "Fried Artichokes — 30 pc",
        price: "$19.99",
        desc: "Family pack of crispy artichoke perfection for the whole crew",
      },
      {
        title: "Spicy Salsalito Sandwich",
        price: "Try it!",
        desc: "Salsalito turkey, chipotle mayo, lettuce, tomato, jalapeño — the crew favorite",
      },
    ],
  },
  {
    id: "coffee",
    label: "Coffee & Tea",
    short: "Coffee & Tea",
    time: "Hot / Iced · S / M",
    items: [
      { title: "Drip Coffee", price: "$2.75 / $3.75", desc: "Freshly brewed, all day" },
      { title: "Espresso", price: "$1.50 / $3.00", desc: "Bold single or double shot" },
      { title: "Americano", price: "$3.50 / $4.50", desc: "Smooth, dark, no fuss" },
      { title: "Cappuccino", price: "$4.50 / $5.50", desc: "Espresso under a cap of silky foam" },
      { title: "Latte", price: "$5.50 / $6.50", desc: "Espresso with steamed milk, any flavor" },
      { title: "Mocha", price: "$5.50 / $6.50", desc: "Chocolate, espresso, steamed milk" },
      { title: "Macchiato", price: "$5.50 / $6.50", desc: "Espresso marked with foam" },
      {
        title: "Biscoff Latte — Special",
        price: "$5.75 / $6.75",
        desc: "Creamy caramelized Biscoff cookie butter, espresso, milk",
      },
      {
        title: "Yemeni Chai Latte — Special",
        price: "$5.75 / $6.75",
        desc: "Aromatic spiced tea, warm cardamom, steamed milk",
      },
      {
        title: "Make It Yours",
        price: "+ extras",
        desc: "Flavors: vanilla, chocolate, caramel, cinnamon, white chocolate, coconut, toffee · syrups .25 · sauces .50 · cold foam 1.25 · extra shot 1.00",
      },
    ],
  },
  {
    id: "breakfast",
    label: "Breakfast",
    short: "Breakfast",
    time: "Mornings ’til 10:30 AM",
    items: [
      {
        title: "Classic Burrito",
        price: "$6.99",
        desc: "Egg, cheese, tater tot, chipotle mayo",
      },
      {
        title: "Bacon Burrito",
        price: "$8.99",
        desc: "Egg, bacon, tater tot, cheese, chipotle mayo",
      },
      {
        title: "Veggie Burrito",
        price: "$7.99",
        desc: "Egg, bell pepper, spinach, cheese, tater tot, salsa verde",
      },
      { title: "Egg Sandwich", price: "$11.50", desc: "Egg, cheese, bacon, mayo" },
      {
        title: "Egg ’N’ Cheese Bagel",
        price: "$5.95",
        desc: "Plain or sesame bagel, egg, cheese, mayo",
      },
      {
        title: "Bagel + Cream Cheese",
        price: "$3.95",
        desc: "Toasted plain or sesame with a thick schmear",
      },
      {
        title: "Breakfast Extras",
        price: "+ add-ons",
        desc: "Bacon 2.00 · avocado .75 · cream cheese .35",
      },
    ],
  },
  {
    id: "byo",
    label: "Build Your Own Sandwich",
    short: "Build Your Own",
    time: "Whole $15.50 · Half $11.50",
    builder: true,
    items: [],
  },
  {
    id: "lunch",
    label: "Lunch Specialties",
    short: "Lunch",
    time: "11:30 AM – 2:30 PM",
    items: [
      {
        title: "Tri-Tip Sandwich",
        price: "$18.00",
        desc: "Grilled onions, aioli, pepper jack cheese",
      },
      {
        title: "Grilled Chicken Sandwich",
        price: "$16.00",
        desc: "Lettuce, tomatoes, onions, pepper jack, garlic aioli",
      },
      { title: "Tri-Tip Burrito", price: "$13.50", desc: "Slow-roasted tri-tip, folded up big" },
      { title: "Chicken Burrito", price: "$11.50", desc: "Grilled chicken, wrapped and ready" },
    ],
  },
];

export const BYO = {
  sizes: [
    { id: "whole", label: "Whole", price: 15.5 },
    { id: "half", label: "Half", price: 11.5 },
  ],
  breads: ["Ciabatta", "Sourdough", "Wheat", "Dutch Crunch"],
  meats: [
    { name: "Turkey", up: 0 },
    { name: "Smoked Turkey", up: 0 },
    { name: "Pastrami", up: 2 },
    { name: "Roast Beef", up: 2 },
    { name: "Tuna", up: 0 },
    { name: "Salami", up: 0 },
    { name: "Ham", up: 0 },
  ],
  cheeses: ["American", "Cheddar", "Pepper Jack", "Swiss", "Monterey Jack", "Provolone"],
  veggies: ["Lettuce", "Tomatoes", "Onions", "Cucumbers", "Pickles", "Mayo", "Mustard"],
  extras: [
    { name: "Avocado", price: 1.75 },
    { name: "Jalapeño", price: 0.75 },
    { name: "Peperoncini", price: 0.75 },
    { name: "Garlic Aioli", price: 0.5 },
    { name: "Honey Mustard", price: 0.5 },
    { name: "Chipotle Mayo", price: 0.75 },
    { name: "Artichoke Hearts", price: 2.5 },
    { name: "Sprouts", price: 0.5 },
  ],
};
